import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Footer from "../../components/user/Footer";
import "../user/style.css";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { deleteData, getData, putData } from "../../api/method";
import TableCart from "../../components/user/Cart/table";
import ModalDelete from "../../components/admin/ModalConfirm";
import TotalCart from "../../components/user/Cart/totalPrice";

const username = localStorage.getItem("username");

function Cart(args) {
  const navigate = useNavigate();

  const [openDel, setOpenDel] = useState(false);

  const toggleDel = () => setOpenDel(!openDel);

  const closeBtnDel = (
    <button className="close" onClick={toggleDel}>
      &times;
    </button>
  );

  const [data, setData] = useState([]);

  const getCart = async () => {
    try {
      const result = await getData(`/api/Cart/user/${username}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCart();
  }, [data]);

  const total = data.reduce(
    (i, item) =>
      (i +=
        (item.quantity * (item.product.price * (100 - item.product.discount))) /
        100),
    0
  );

  const [dataDel, setDataDel] = useState([]);

  const getCartByDel = async (id) => {
    try {
      const result = await getData(`/api/Cart/${id}`);
      setDataDel(result.data);
      setOpenDel(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitDel = async (id) => {
    try {
      const res = await deleteData(`/api/Cart/${id}`);
      if (res.status === 200) {
        setOpenDel(false);
        toast.success("Delete success!");
      }
    } catch (err) {
      console.log(err);
      setOpenDel(false);
      toast.error("Delete fail!");
    }
  };

  const getCartByEdit = async (id) => {
    try {
      const result = await getData(`/api/Cart/${id}`);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getProduct = async (id) => {
    try {
      const result = await getData(`/api/Product/${id}`);
      return result.data;
    } catch (error) {
      console.log(error);
    }
  };

  const onAdd = async (id) => {
    const dataEdit = await getCartByEdit(id);

    const dataProduct = await getProduct(dataEdit.productId);
    const count = dataProduct.quantity;

    console.log(count);

    const editData = new FormData();

    if (dataEdit.quantity < count) {
      editData.append("id", id);
      editData.append("quantity", dataEdit.quantity + 1);
      editData.append("productId", dataEdit.productId);
      editData.append("userId", dataEdit.userId);

      try {
        const res = await putData(`/api/Cart/${id}`, editData);
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("Product quantity is out!");
    }
  };

  const onRemove = async (id) => {
    const dataEdit = await getCartByEdit(id);

    if (dataEdit.quantity > 1) {
      const editData = new FormData();

      editData.append("id", id);
      editData.append("quantity", dataEdit.quantity - 1);
      editData.append("productId", dataEdit.productId);
      editData.append("userId", dataEdit.userId);

      try {
        const res = await putData(`/api/Cart/${id}`, editData);
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    } else {
      handleSubmitDel(id);
    }
  };

  return (
    <div className="pt-3">
      <div className="bg_breadcrumb">
        <p className="fs-3 fw-bold t-white text-center t-breadcrumb">Cart</p>
      </div>

      <Container className="py-5 d-flex">
        <TableCart
          data={data}
          onRemove={(id) => onRemove(id)}
          onAdd={(id) => onAdd(id)}
          getCartByDel={(id) => getCartByDel(id)}
        />

        <div className="border_center mx-4"></div>

        <TotalCart total={total} />
      </Container>

      <ModalDelete
        title="Delete"
        text="Are you sure you want to remove the product from your cart?"
        toggle={toggleDel}
        close={closeBtnDel}
        isOpen={openDel}
        onClick={() => handleSubmitDel(dataDel.id)}
      />

      <Footer />
    </div>
  );
}

export default Cart;
